import Link from '@tiptap/extension-link';

declare module '@tiptap/core' {
	interface Commands<ReturnType> {
		customLinkExt: {
			underlineStyle: (className: string) => ReturnType;
		};
	}
}

export const CustomLinkExt = Link.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			class: {
				default: ''
			}
		};
	},
	addCommands() {
		return {
			...this.parent?.(),
			underlineStyle:
				className =>
				({ commands }) => {
					return commands.updateAttributes('link', { class: className });
				}
		};
	}
});
